const messages = {
  en: {
    proveedor: {
      title: 'Proveedor management',
      menuTitle: 'Suppliers',
      subtitle: 'View, search, create, edit and delete Proveedor',
      creating: 'Creating Proveedor',
      editing: 'Editing Proveedor',
      deleting: 'Deleting Proveedor',
      showing: 'Showing Proveedor',
      ordenCompraReminderTitle: 'Purchase order data',
      ordenCompraReminderText:
        'The name, CUIT, email and phone you enter here are the details that will be shown on the purchase order PDF when you generate it for this supplier. Check that they are correct before continuing.',
      labels: {
        nombre: 'Name (unique)',
        cuit: 'CUIT',
        email: 'Email',
        telefono: 'Phone',
        deuda: 'Balance due',
      },
    },
  },
  es: {
    proveedor: {
      title: 'Administración de Proveedores',
      menuTitle: 'Proveedores',
      subtitle: 'Ver, buscar, crear, editar y borrar Proveedores',
      creating: 'Creando Proveedor',
      editing: 'Modificando Proveedor',
      deleting: 'Eliminando Proveedor',
      showing: 'Detalles de Proveedor',
      ordenCompraReminderTitle: 'Datos en la orden de compra',
      ordenCompraReminderText:
        'El nombre, CUIT, email y teléfono que cargás acá son los que van a figurar en el PDF de la orden de compra cuando la generes para este proveedor. Verificá que estén bien antes de continuar.',
      labels: {
        nombre: 'Nombre (único)',
        cuit: 'CUIT',
        email: 'Email',
        telefono: 'Teléfono',
        deuda: 'Deuda',
      },
    },
  },
  pt: {
    proveedor: {
      title: 'Administração de Fornecedores',
      menuTitle: 'Fornecedores',
      subtitle: 'Ver, buscar, criar, editar e excluir Fornecedores',
      creating: 'Criando Fornecedor',
      editing: 'Editando Fornecedor',
      deleting: 'Excluindo Fornecedor',
      showing: 'Detalhes do Fornecedor',
      ordenCompraReminderTitle: 'Dados no pedido de compra',
      ordenCompraReminderText:
        'O nome, CUIT, e-mail e telefone informados aqui são os que aparecerão no PDF do pedido de compra quando você o gerar para este fornecedor. Confira se estão corretos antes de continuar.',
      labels: {
        nombre: 'Nome (único)',
        cuit: 'CUIT',
        email: 'Email',
        telefono: 'Telefone',
        deuda: 'Dívida',
      },
    },
  },
}

export default messages
